import { render } from "./RemindersPage.vue?vue&type=template&id=1bb7830a"
import script from "./RemindersPage.vue?vue&type=script&lang=js"
export * from "./RemindersPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__